export default "__VITE_ASSET__ff5368bd__"